export const DRCC_REGEX = new RegExp("^/cloud-providers/drcc/compartments/[^/]+$");
